<template>
    <b-container fluid id="id_layout" style="padding: 0px !important; width: 100%; overflow-y: hidden">
        <b-row style="padding: 0 !important; margin: 0 !important;">
            <b-col class="sidebar-col" style="max-width: 15% !important; flex: 0 0 15% !important;">
                <Sidebar />
            </b-col>
            <b-col class="right-col"  style="padding: 0 !important;; max-width: 85% !important; margin: 0px !important; flex: 0 0 85% !important;  overflow-y: hidden">
                <NavBar />
                <router-view></router-view>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import NavBar from '@/components/Global/Navbar'
    import Sidebar from '@/components/Global/Sidebar'
    import '@/assets/scss/app_web.scss'
    export default {
        name: 'Home',
        components: {
            NavBar,
            Sidebar
        },
        data: () => ({

        }),
        methods: {}
    }
</script>
<style scoped>
</style>